export default function ContentFrame({ 
    children,
    className = '',
    titleText = '',
    titleIcon = null,
    titleAction = null,
    toolTipText = null
}) {
    return (
        <div 
            className={`
                w-full flex flex-col items-center justify-center bg-white border border-gray-200 shadow-md rounded-2xl overflow-hidden
                ${className}
            `}
        >
            {titleText &&
                <h2 
                    className={`
                        w-full py-2 border-b border-gray-200 flex items-center justify-center gap-x-2 text-center relative group z-20 text-sm 2xl:text-base
                        ${titleAction ? 'cursor-pointer' : ''}
                    `}
                    onClick={titleAction}
                >
                    {titleText}

                    {titleIcon}

                    {toolTipText && (
                        <div className="absolute left-1/2 top-full transform -translate-x-1/2 mt-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-30">
                            {toolTipText}
                        </div>
                    )}
                </h2>
            }

            {children}

        </div>
    )
}